import { useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Registration } from './components/Registration';
import { ForgotPasswordForm } from './components/ForgotPasswordForm';
import { LoginForm } from './components/LoginForm';
import { ResetPasswordForm } from './components/ResetPassword';
import { CreatePassword } from './components/CreatePassword';
import WebGLBackground from './components/WebGLBackground';
import './styles/login.css';

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body');
    return () => {
      document.body.classList.remove('bg-body');
    };
  }, []);

  return (
    <div className="fixed inset-0 w-screen h-screen bg-gradient-to-br from-[#f0f4ff] via-[#e8edf7] via-60% to-[#f5f7fa] overflow-hidden z-0">
      <WebGLBackground />
      {/*<WebGLBackground />*/}
      <div className="fixed inset-0 z-10 flex items-center justify-center w-screen h-screen p-4">
        <Outlet />
      </div>
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<LoginForm />} />
      <Route path="registration" element={<Registration />} />
      <Route path="forgot-password" element={<ForgotPasswordForm />} />
      <Route
        path="reset-password/:token/:userGuid/:email"
        element={<ResetPasswordForm />}
      />
      <Route
        path="create-password/:token/:userGuid/:email"
        element={<CreatePassword />}
      />
      <Route index element={<LoginForm />} />
    </Route>
  </Routes>
);

export { AuthPage, AuthLayout };
